import { makeAutoObservable, runInAction } from "mobx";

export default class ResearchPublicationStore {
  researchPublications = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.researchPublications = [];
    runInAction(() => {
      this.researchPublications = data;
    });
  };

  deleteItem = (id) => {
    let newState = this.researchPublications.filter((item) => item.id !== id);
    this.researchPublications = [];
    this.researchPublications = newState;
  };
}
